import {useEffect, useMemo} from 'react';
import {observer} from 'mobx-react';
import {useLDClient} from '@launchdarkly/react-sdk';
import {useStores} from 'hooks/useStores';
import {buildLDContext} from '../launch-darkly';
import type {MeForContext} from '../launch-darkly';

const LaunchDarklyIdentifyComponent = () => {
  const ldClient = useLDClient();
  const stores = useStores() as unknown as {
    meStore: {isAuthenticated: () => boolean; me: MeForContext};
  };
  const {meStore} = stores;

  const isAuthenticated = meStore.isAuthenticated();
  const context = useMemo(
    () => buildLDContext(isAuthenticated ? meStore.me : null),
    [isAuthenticated, meStore.me],
  );
  const contextKey = JSON.stringify(context);

  useEffect(() => {
    if (!ldClient) return;
    ldClient.identify(context).catch((err: Error) => {
      console.error(err);
    });
  }, [ldClient, contextKey, context]);

  return null;
};

export const LaunchDarklyIdentify = observer(LaunchDarklyIdentifyComponent);
